import React, { useEffect } from "react";
import {
  ThemeProvider,
  StylesProvider,
  jssPreset,
} from "@material-ui/core/styles";
import { CssBaseline } from "@material-ui/core";
import theme from "./theme/theme";
import { create } from "jss";
import rtl from "jss-rtl";
import MasterLayout from "./components/Layout/MasterLayout";
import AlertContextProvider from "./contexts/AlertContext";
import { Router } from "react-router";
import history from "./utilize/history";

// import ReactGA from "react-ga";

// ReactGA.initialize("G-ZNLHL32S4E");
const jss = create({ plugins: [...jssPreset().plugins, rtl()] });

function App() {
  //google analytics
  //   useEffect(() => {
  //     ReactGA.pageview(window.location.pathname + window.location.search);
  // }, [window.location.pathname]);

  return (
    <Router history={history}>
      <ThemeProvider theme={theme}>
        <StylesProvider jss={jss}>
          <AlertContextProvider>
            <CssBaseline />
            <MasterLayout />
          </AlertContextProvider>
        </StylesProvider>
      </ThemeProvider>
    </Router>
  );
}
export default App;
